export default __webpack_public_path__ + "static/media/markets.bc02bb80.svg";